import React, { Fragment, useEffect, useState, useRef } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
import { loginUser, logoutUser, GetCaptcha, SetLoginError } from '../../common/actions/userActions';
import connect from 'react-redux/lib/connect/connect';
import store from '../../common/store';
import { checkLoginIdstr, isEmpty } from '../../common/cores';
import Link from 'react-router-dom/Link';

const Login = (props) => {

    const { loginError, captchaData } = props.user
    // console.log(props)
    const [loginIdErr, setLoginIdErr] = useState("")
    const [loginPwdErr, setLoginPwdErr] = useState("");
    const [captchaErr, setCaptchaErr] = useState("");

    const [inputs, setInputs] = useState({
        loginId: '',
        loginPwd: '',
        captcha: '',
    });
    const loginRef = useRef();
    const { loginId, loginPwd, captcha } = inputs;
    let captchaId = !isEmpty(captchaData) && captchaData.captchaId;
    //   const dispatch = useDispatch();

    const onChange = (e) => {
        const { value, name } = e.target; // 우선 e.target 에서 name 과 value 를 추출
        setInputs({
            ...inputs, // 기존의 input 객체를 복사한 뒤
            [name]: value // name 키를 가진 값을 value 로 설정
        });
        setLoginIdErr('');
        setLoginPwdErr('');
        setCaptchaErr('');
        if (!isEmpty(loginError)) {
            props.SetLoginError('');
        }
    };

    const onReset = () => {
        setInputs({
            loginId: '',
            loginPwd: '',
            captcha: ''
        })
    };
    const onCaptcha = () => {
        store.dispatch(GetCaptcha())
            .then(() => {

            })
    }

    useEffect(() => {
        onCaptcha();
        loginRef.current.focus();
    }, []);


    const captchaRefresh = () => {
        onCaptcha();
    }

    const onSubmit = (e, type) => {
        setInputs({
            loginId: loginId,
            loginPwd: loginPwd,
            captcha: ""
        })
        e.preventDefault();
        if (checkLoginIdstr(loginId)) {
            setLoginIdErr("아이디에 특수문자를 포함할수 없습니다.")
            return;
        } else if (isEmpty(loginId) && isEmpty(loginPwd) && isEmpty(captcha)) {
            setLoginIdErr("아이디를 입력해주세요.");
            setLoginPwdErr("비번을 입력해주세요.");
            setCaptchaErr("보안문자를 입력해주세요.");
            return;
        }
        else if (isEmpty(loginId)) {
            setLoginIdErr("아이디를 입력해주세요.");
            return;
        } else if (isEmpty(loginPwd)) {
            setLoginPwdErr("비번을 입력해주세요.");
            return;
        } else if (isEmpty(captcha)) {
            setCaptchaErr("보안문자를 입력해주세요.");
            return;
        } else {

            let params = {
                loginId,
                loginPwd,
                captchaId,
                captcha
            }
            store.dispatch(loginUser(params))
                .then(() => {
                    setLoginIdErr("");
                    setLoginPwdErr("");
                    setCaptchaErr("");
                    props.history.push("/");
                }
                );
        }
    }


    const onEnter = (e) => {
        // e.preventDefault();

        if (e.key === 'Enter') {
            // e.preventDefault();
            onSubmit(e);
        }
    }

    useEffect(() => {
        if (props.isAuthenticated)
            props.logoutUser();
    }, [])

    return (
        <Fragment>
            <div className="title_wrap title_login" style={{top : '140px'}}>
                <div className="title_box">
                    <div className="title">로그인</div>
                </div>
            </div>

            <div className="contents_wrap contents_login" style={{top : '150px'}}>
                <div className="contents_box">
                    <div className="con_box00">
                        <div className="write_wrap">
                            <div className="write1">
                                <div className="con_box00">
                                    <div className="login_box_box">
                                        <div className="login_box_title"><img src="images/logo.png" alt="" style={{maxWidth : '100%'}}/></div>
                                        <div className="login_box_item" onKeyDown={onEnter}>
                                            {/*  */}
                                            <input type="text"
                                                name="loginId"
                                                className="login_input"
                                                placeholder="아이디를 입력하세요"
                                                ref={loginRef}
                                                onChange={onChange} />
                                            <span className="color-danger font-bold m-d-block m-w-100" style={{ fontSize: "1rem", display: isEmpty(loginError) && "block", height: "20px" }}>&ensp;{isEmpty(loginIdErr) ? " " : loginIdErr}
                                            </span>
                                            {/*  */}
                                            <input type="password"
                                                name="loginPwd"
                                                className="login_input"
                                                placeholder="비밀번호를 입력하세요"
                                                onChange={onChange} />
                                            <span className="color-danger font-bold m-w-100" style={{ fontSize: "1rem", display: isEmpty(loginError) && "block", height: "20px" }}>&ensp;{isEmpty(loginPwdErr) ? " " : loginPwdErr}</span>
                                            {/*  */}
                                            <input className="login_input" name="captcha" type="text" value={captcha} maxLength={4} placeholder="보안문자를 입력하세요" inputMode="text" onChange={onChange} />
                                            <div className='captcha_input'>
                                                <div className='captcha_img' >
                                                    <img style={{ height: "50px", width: "100%" }} src={captchaData.image} alt="" />
                                                </div>
                                                <button className="margin-left-5 captcha_refresh font-normal" onClick={captchaRefresh}><i className='fa fa-refresh'></i></button>
                                            </div>
                                            <span className="color-danger font-bold m-w-100" style={{ fontSize: "1rem", display: "block", height: "20px" }}>{isEmpty(captchaErr) ? " " : captchaErr}</span>
                                            <a className="login_btn1" onClick={onSubmit}>로그인</a>
                                            <Link to="/register" className="login_btn2">회원가입</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    isAuthenticated: state.user.isAuthenticated,
    user: state.user
});

export default connect(mapStateToProps, { loginUser, logoutUser, SetLoginError })(Login);


// WEBPACK FOOTER //
// ./src/components/Layout/Login.js